import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.25 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-3.552a.8.8 0 0 1-.046.213L10.057 19.25H14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1 0-1.5h3.465a1 1 0 0 1 .033-.113L13.88 4.75H10A.75.75 0 0 1 9.25 4",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }